export default {
    SET_ADDITIONAL_LOCATION({commit}, additionalLocations) {
        commit('SET_ADDITIONAL_LOCATION', additionalLocations)
    },
    SET_LOCATION_TYPE({commit}, locationTypes) {
        commit('SET_LOCATION_TYPE', locationTypes)
    }
}